import React__default from 'react';
import { GenericConfigSection } from './GenericConfigSection.js';

const ConfigSection = ({ children, ...props }) => {
  return /* @__PURE__ */ React__default.createElement(GenericConfigSection, { ...props, kind: "section" }, children);
};

export { ConfigSection };
//# sourceMappingURL=ConfigSection.js.map
